import React from 'react';
import CompactCard from './CompactCard';

const SectionScroller = ({ title, events, formatEventDate, onOpenModal }) => {
  if (events.length === 0) return null;
  return (
    <div className="mb-8">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-xl md:text-2xl font-black text-gray-900">{title}</h3>
      </div>
      <div className="overflow-x-auto no-scrollbar snap-x snap-mandatory overscroll-contain">
        <div className="flex gap-3 w-max pb-2">
          {events.map(ev => (
            <CompactCard
              key={ev._id}
              event={ev}
              formatEventDate={formatEventDate}
              onOpenModal={onOpenModal}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default SectionScroller;
